import '../styles/BrandStyles.css'
import NameIcon from '../assets/NameIcon';
export default function Brand() {
    return (
        <a className="brand__container" href="/" >
            <NameIcon />
        </a>
    )
}